<div>
  <!-- Header with title and edit toggle button -->
  <div class="d-flex">
    <ng-content select="[title]"></ng-content>
    @if (showTitle()) {
      <h5 class="mt-auto small-caps">WiFi settings</h5>
    }
    @if (allowToggle()) {
      <button type="button"
              class="btn btn-outline-primary border-0 ms-auto"
              (click)="toggleEditing()">
        @if (!editing()) {
          <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
        } @else {
          <fa-icon [icon]="['far', 'save']"></fa-icon>
        }
      </button>
    }
  </div>

  @if (editing()) {
    <!-- Edit Mode: Use FormComponent -->
    <era-form [fields]="fields"
              [showSubmitButton]="showSubmitButton()"
              (formSubmit)="onFormSubmit($event)"></era-form>
  } @else {
    <!-- View Mode: WiFi Profile Configuration Table -->

    <!-- WiFi Profile Configuration Table -->
    <table class="table table-sm table-list">
      <thead>
        <tr>
          <th colspan="2"
              scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th title="SSID of the Wi-Fi network to be used. In iOS 7.0 and later, this is optional if a DomainName value is provided."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            <label for="ssidStr"
                   class="col-form-label"
                   i18n>Service Set Identifier (SSID)</label>
          </th>
          <td>
            <label for="ssidStr"
                   class="col-form-label">{{ wifiProfile()?.SSID_STR }}</label>
          </td>
        </tr>

        <tr>
          <th title="Besides SSID, the device uses information such as broadcast type and encryption type to differentiate a network. By default (false), it is assumed that all configured networks are open or broadcast. To specify a hidden network, must be true."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            <label for="hiddenNetwork"
                   class="col-form-label"
                   i18n>Hidden network</label>
          </th>
          <td class="align-middle">
            <label for="hiddenNetwork"
                   class="col-form-label">
              <ml-yes-no-icon [flag]="wifiProfile()?.HIDDEN_NETWORK"></ml-yes-no-icon>
            </label>
          </td>
        </tr>

        <tr>
          <th title="Optional. Default true. If true, the network is auto-joined. If false, the user has to tap the network name to join it. Availability: Available in iOS 5.0 and later and in all versions of macOS."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            <label for="autoJoin"
                   class="col-form-label"
                   i18n>Auto join</label>
          </th>
          <td class="align-middle">
            <label for="autoJoin"
                   class="col-form-label">
              <ml-yes-no-icon [flag]="wifiProfile()?.autoJoin"></ml-yes-no-icon>
            </label>
          </td>
        </tr>

        <tr>
          <th title="Optional. Default true. If true, the network is auto-joined. If false, the user has to tap the network name to join it. Availability: Available in iOS 5.0 and later and in all versions of macOS."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            <label for="encryptionType"
                   class="col-form-label"
                   i18n>Encryption type</label>
          </th>
          <td>
            <label for="encryptionType"
                   class="col-form-label">{{ wifiProfile()?.encryptionType }}</label>
          </td>
        </tr>

        <!-- Proxy Configuration Section -->
        <tr>
          <th title="Optional. Default true. If true, the network is auto-joined. If false, the user has to tap the network name to join it. Availability: Available in iOS 5.0 and later and in all versions of macOS."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            <label for="proxyType"
                   class="col-form-label"
                   i18n>Proxy type</label>
          </th>
          <td>
            <label for="proxyType"
                   class="col-form-label">{{ wifiProfile()?.proxyType }}</label>
          </td>
        </tr>

        <!-- Manual Proxy Configuration -->
        @if (wifiProfile()?.proxyType === 'Manual') {
          <tr>
            <th title="The proxy server's network address."
                data-toggle="tooltip"
                data-placement="right"
                scope="row">
              <label for="proxyServer"
                     class="col-form-label ps-2"
                     i18n>Proxy server</label>
            </th>
            <td>
              <label for="proxyServer"
                     class="col-form-label ps-2">{{ wifiProfile()?.proxyServer }}</label>
            </td>
          </tr>
          <tr>
            <th title="The proxy server's port."
                data-toggle="tooltip"
                data-placement="right"
                scope="row">
              <label for="proxyServerPort"
                     class="col-form-label ps-2"
                     i18n>Proxy server port</label>
            </th>
            <td>
              <label for="proxyServerPort"
                     class="col-form-label ps-2">{{ wifiProfile()?.proxyServerPort }}</label>
            </td>
          </tr>
          <tr>
            <th title="Optional. The username used to authenticate to the proxy server."
                data-toggle="tooltip"
                data-placement="right"
                scope="row">
              <label for="proxyUsername"
                     class="col-form-label ps-2"
                     i18n>Proxy username</label>
            </th>
            <td>
              <label for="proxyUsername"
                     class="col-form-label ps-2">{{ wifiProfile()?.proxyUsername }}</label>
            </td>
          </tr>
          <tr>
            <th title="Optional. The password used to authenticate to the proxy server."
                data-toggle="tooltip"
                data-placement="right"
                scope="row">
              <label for="proxyPassword"
                     class="col-form-label ps-2"
                     i18n>Proxy password</label>
            </th>
            <td>
              <label for="proxyPassword"
                     class="col-form-label ps-2">{{ wifiProfile()?.proxyPassword ? '******' : '' }}</label>
            </td>
          </tr>
        }
        <!-- Auto Proxy Configuration (PAC) -->
        @else if (wifiProfile()?.proxyType === 'Auto') {
          <tr>
            <th title="Optional. The URL of the PAC file that defines the proxy configuration."
                data-toggle="tooltip"
                data-placement="right"
                scope="row">
              <label for="proxyPACURL"
                     class="col-form-label ps-2"
                     i18n>Proxy PAC Url</label>
            </th>
            <td>
              <label for="proxyPACURL"
                     class="col-form-label ps-2">{{ wifiProfile()?.proxyPACURL }}</label>
            </td>
          </tr>
          <tr>
            <th title="Optional. If false, prevents the device from connecting directly to the destination if the PAC file is unreachable. Default is false. Availability: Available in iOS 7 and later."
                data-toggle="tooltip"
                data-placement="right"
                scope="row">
              <label for="proxyPACFallbackAllowed"
                     class="col-form-label ps-2"
                     i18n>Proxy Allow PAC fallback</label>
            </th>
            <td class="align-middle">
              <label for="proxyPACFallbackAllowed"
                     class="col-form-label ps-2">
                <ml-yes-no-icon [flag]="wifiProfile()?.proxyPACFallbackAllowed"></ml-yes-no-icon>
              </label>
            </td>
          </tr>
        }

        <!-- Network Security Settings -->
        <tr>
          <th title="Optional. If set to true, Captive Network detection will be bypassed when the device connects to the network. Defaults to false."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            <label for="captiveBypass"
                   class="col-form-label"
                   i18n>Captive bypass</label>
          </th>
          <td class="align-middle">
            <label for="captiveBypass"
                   class="col-form-label">
              <ml-yes-no-icon [flag]="wifiProfile()?.captiveBypass"></ml-yes-no-icon>
            </label>
          </td>
        </tr>

        <!-- MAC Randomization Setting -->
        <tr>
          <th title="If true, disables MAC address randomization for a Wi-Fi network while associated with that network. This feature also shows a privacy warning in Settings indicating that the network has reduced privacy protections.
        If false, then the system enables MAC address randomization.
        This value is only locked when MDM installs the profile. If the profile is manually installed, the system sets the value but the user can change it. Available in iOS 14 and later, macOS 15 and later, and watchOS 7 and later."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            <label for="disableAssociationMACRandomization"
                   class="col-form-label"
                   i18n>Disable Association MAC Randomization</label>
          </th>
          <td class="align-middle">
            <label for="disableAssociationMACRandomization"
                   class="col-form-label">
              <ml-yes-no-icon [flag]="wifiProfile()?.disableAssociationMACRandomization"></ml-yes-no-icon>
            </label>
          </td>
        </tr>

        <!-- WiFi Password with visibility toggle-->
        <tr>
          <th title="The Wi-Fi password."
              data-toggle="tooltip"
              data-placement="right"
              scope="row">
            <label for="password"
                   class="col-form-label"
                   i18n>Password</label>
          </th>
          <td>
            <label for="password"
                   class="col-form-label">{{ wifiProfile()?.password ? '******' : '' }}</label>
          </td>
        </tr>
      </tbody>
    </table>
  }
</div>